import React from "react";

const FilePngIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (props) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29 21H27.1111C26.6101 21 26.1297 21.1844 25.7755 21.5126C25.4212 21.8408 25.2222 22.2859 25.2222 22.75V26.25C25.2222 26.7141 25.4212 27.1593 25.7755 27.4874C26.1297 27.8156 26.6101 28 27.1111 28H29V24.5H28.0556M12 28V21H13.8889C14.3899 21 14.8703 21.1844 15.2245 21.5126C15.5788 21.8408 15.7778 22.2859 15.7778 22.75C15.7778 23.2141 15.5788 23.6593 15.2245 23.9874C14.8703 24.3156 14.3899 24.5 13.8889 24.5H12M18.6111 28V21L22.3889 28V21"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.7513 34.833H16.9862C11.8226 34.833 9.24079 34.833 7.44783 33.5698C6.93412 33.2078 6.47805 32.7786 6.09349 32.2951C4.7513 30.6076 4.7513 28.1777 4.7513 23.3179V19.2876C4.7513 14.5959 4.7513 12.25 5.49378 10.3764C6.68742 7.36443 9.21177 4.98857 12.412 3.86515C14.4027 3.16634 16.8952 3.16634 21.8801 3.16634C24.7286 3.16634 26.1529 3.16634 27.2904 3.56566C29.1191 4.20762 30.5616 5.56524 31.2437 7.2864C31.668 8.35701 31.668 9.6975 31.668 12.3785V15.833"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.7487 19C4.7487 16.0852 7.11164 13.7222 10.0265 13.7222C11.0806 13.7222 12.3234 13.9069 13.3484 13.6323C14.259 13.3883 14.9703 12.677 15.2143 11.7663C15.489 10.7414 15.3043 9.4986 15.3043 8.44444C15.3043 5.52961 17.6672 3.16667 20.582 3.16667"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default FilePngIcon;
